import { jsx as _jsx } from "react/jsx-runtime";
import { Field } from "@headlessui/react";
function WPQTField({ children, className }) {
    return _jsx(Field, { className: className, children: children });
}
export { WPQTField };
